<template>
<div class="mainLayout">
	<section class="listLayout">
		<div class="videoElement" v-for="video in firebaseByDate" :key="video.id">
			<div class="left">
				<div class="votes-cont">
					<div class="votes-label">Voti</div>
					<div class="votes-counter">{{video.votes}}</div>
				</div>
			<!-- <video-preview v-for="video in firebaseByVotes" :key="video.videoID" :videoID="video.videoID" :elID="video.id" :votes="video.votes" ></video-preview> -->
			</div>
			<div class="right">
				<videoplayer :videoID="video.videoID" :elID="video.id" previewType="image" :vote="false"></videoplayer>
			</div>
		</div>
	</section>
</div>
</template>
<script>
	import sortBy from 'lodash/sortBy'
	import reverse from 'lodash/reverse'

	export default {
		name: 'listLayout',
		data () {
			return {
				videos: []
			}
		},
		computed:{
			firebaseByDate: function(){

				if((this.$root.anArray)&&(this.$root.anArray.length > 1)){
					return reverse(sortBy(
						this.$root.mostRecent,
						['date'] , 
						['asc']
					))
				}else{
					var vjs = this;
					this.$getItem("listVotes", function(err, data){
						if(err){
							vjs.videos = reverse(
								sortBy(vjs.$root.mostRecent, 
									['date'] , 
									['asc'] )
							);
							// alert("vjs.$root.anArray");
							return false;
						}
						// alert("reverse(sortBy(data, ['votes'], ['asc']))");
						vjs.videos = reverse(sortBy(data, ['date'], ['asc']));
						return true;
					});
					return this.videos;
				}

				return reverse(sortBy(
					this.$root.mostRecent,
					['date'] , 
					['asc']
				))
			},
		},
		components:{
			// videoPreview,
			videoplayer: () => import('./videoPlayer')
		},
		/*
		beforeRouteLeave: (to, from, next) =>{
			// console.log(to);
			if((this.$root)){
				this.$root.menuOpened = false;
			}
			// next();
		}
		*/
		beforeDestroy: function(){
			this.$root.closeMenu()
		}
	}
</script>
<style lang="less">
	.listLayout{
		max-width: 760px;
		margin:auto;
		.videoElement{
			display: flex;
			width:100%;
			.left{
				min-width:15%;
				padding-right:20px;
				box-sizing: border-box;
			}
			.right{
				width:80%;
			}
		}
	}
	.votes-cont{
		display:block;
		padding:20px;
		background: white;
		box-shadow: 0 3px 15px rgba(0,0,0,.31);
		.votes-label{
			font-size: 18px;
			margin-bottom: 10px;
			text-transform: uppercase;
		}
		.votes-counter{
			font-size: 20px;
			font-weight: bold;
			font-family: 'Freckle Face', cursive;
		}
	}
</style>


// WEBPACK FOOTER //
// mostRecententLayout.vue?d5067b2a